<template>

	<!-- COMPONENTE DE CADASTRO INICIO -->
    <ApolicesForm
      :open= "apolicesFormOpen"
      @update-open= "apolicesFormOpen = false"
      :inputsList="inputs"
      :title= "headerInfo.title"
      @data= "onSendFormData"
      @editing-data= "onSendEditingData"
      :placeHolderValues= "editFormData"
      :resetFormData= "resetFormData"
    />

    <FilterComponent
      :title="'Apólices'"
      :open="openFilter"
      :fields="filterFields"
      @apply-filters="handleFilters"
      @update-open="openFilter = false"
    />

	<Commonlisting
		:listingData = "data"
		:headersData = "headers"
		:headerInfo = "headerInfo"
		:inputsListing= "inputs"
		:previous = "previous"
		:next = "next"
		:fileOnly="false"
		:currentPage = "currentPage"
		:totalPages = "totalPages"
		:totalRecords = "totalRecords"
		:editFormData= "editFormData"
		:importFile= "false"
		:useForms= "false"
		:resetFormData= "resetFormData"
		@previous-page= "pageData"
		@next-page= "pageData"
		@go-to-page= "goTo"
		@find-by-field= "filtered"
		@new-alternative="apolicesFormOpen = true"
		@clean-filter= "cleanFilter"
		@delete-data-id= "deleteData"
		@edit-alternative= "getEditData"
		@filter="openFilter = true"
	/>
</template>
<script>

import Commonlisting from '@/components/generalcomponents/CommonListing';
import ApolicesRepository from '@/services/ApolicesRepository.vue';
import { pageVariables } from '@/views/insideviews/apolices/PageVariablesApolices';
import { handleUnauthorized } from '@/services/AuthSer/authServiceFunction';
import ApolicesForm from './ApolicesForm.vue';
import FilterComponent from "@/components/generalcomponents/CommonFilter.vue";

export default {
	name: 'ApolicesView',
	async created(){
		this.onlineUser = JSON.parse(window.localStorage.getItem("myUser") || "{}");
		this.pageData(this.page)
	},
	data() {
		return {
			...pageVariables,
			data: [],
			previous: '',
			next: '',
			totalPages: 0,
			totalRecords: 0,
			currentPage: 0,
			resetFormData: false,
			editFormData:{},
			onlineUser: JSON.parse(window.localStorage.getItem("myUser")),
			apolicesFormOpen: false,
			openFilter: false,
			filterFields: [
				{
					name: "nome",
					label: "Nome da Apólice",
					type: "input",
					placeholder: "Busque pelo nome..."
				},
				{
					name: "numero",
					label: "Número da Apólice",
					type: "input",
					placeholder: "Busque pelo número..."
				}
			]
		};
	},
	props: {
	},
	methods: {
		async pageData(page){
			this.loading = true; 
			const apolicesRepo = new ApolicesRepository();
			try {
				const response = await apolicesRepo.getApolices(this.onlineUser.token,page);
				if (response?.status  === 200) {
					this.data = response.data.data.map(item => {
						delete item.data_aniversario_apolice;
						return item;
					});
					this.totalPages = response.data.last_page;
					this.totalRecords = response.data.total;
					this.currentPage = response.data.current_page;

				if (response.data.next_page_url) {
					this.next = response.data.next_page_url;
				}else{
					this.next = ""
				}
				if (response.data.prev_page_url) {

					this.previous = response.data.prev_page_url;
				}else{
					this.previous = ""
				}
				this.loading = false; 

				}
			} catch (error) {
				this.loading = false; 
				handleUnauthorized(error); 
			}
		},
		async onSendFormData(data){
			const apolicesRepo = new ApolicesRepository();
			try {
				console.log(data)
				const response = await apolicesRepo.createApolice(this.page,data,this.onlineUser.token);
				if (response?.status === 201) {
					this.pageData(this.page);
					this.resetForm();
				} else {
					this.error = response?.message;
				}
			} catch (error) {
				handleUnauthorized(error); 
			}	
		},
		async onSendEditingData(data,id){
			const apolicesRepo = new ApolicesRepository();
			try {
				console.log(data)
				const response = await apolicesRepo.updateApolice(this.page,this.onlineUser.token,id,data);
				if (response?.status === 200) {
					this.pageData(this.page);
					this.resetForm();
					this.apolicesFormOpen = false;
				} else {
					this.error = response?.message;
				}
			} catch (error) {
				handleUnauthorized(error); 
			}	
		},
		async deleteData(id){
			const apolicesRepo = new ApolicesRepository();
			try {
				const response = await apolicesRepo.deleteApolice(this.page,this.onlineUser.token,id);
				if (response?.status === 204) {
					this.pageData(this.page);

				} else {
					this.error = response?.message;
				}
			} catch (error) {
				handleUnauthorized(error); 
			}	
		},
		async getEditData(id){
			console.log('Iniciando edição da apólice ID:', id);
			this.editFormData = {}; // Limpa dados anteriores
			this.apolicesFormOpen = true; // Abre imediatamente para dar feedback
			const apolicesRepo = new ApolicesRepository();
			try {
				const response = await apolicesRepo.getApolice(this.page,this.onlineUser.token,id);
				if (response?.status === 200) {
					console.log('Dados da apólice carregados:', response.data);
					this.editFormData = response.data;
				} else {
					console.error('Erro ao buscar dados da apólice:', response);
					this.error = response?.message;
					this.apolicesFormOpen = false; // Fecha se der erro
				}
			} catch (error) {
				handleUnauthorized(error); 
			}	
		},
		goTo(number){
			this.pageData(this.page+"?page="+number)
		},
		filtered(filteredData){
			const key = this.seachFilterKey;
			const value = filteredData;
			if (key) {
				this.pageData(this.page+"?"+key+'='+value);
			}
		},
		cleanFilter(){
		this.pageData(this.page)	
		},
		handleFilters(rawFilters){
			this.openFilter = false;
			let queryParams = [];
			for (const key in rawFilters) {
				if (rawFilters[key]) {
					queryParams.push(`${key}=${rawFilters[key]}`);
				}
			}
			const queryString = queryParams.length ? '?' + queryParams.join('&') : '';
			this.pageData(this.page + queryString);
		},
		resetForm() {
			this.resetFormData = true;
			this.$nextTick(() => {
				this.resetFormData = false;
			});
		}
	},
	components:{
		Commonlisting,
		ApolicesForm,
		FilterComponent
	},
	setup() {
	return {
	}
	}}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
